import { useNavigate } from 'react-router-dom';
import { AppRouteConfigs, MenuItems } from 'src/app/AppRoutes';
import { CommandOptionDisplay } from 'src/contexts/CommandMenuContext/CommandMenuContext';
import { useCommandMenuOptions } from 'src/hooks/api/useCommandMenuOptions';
import { useToggleTheme } from 'src/hooks/useToggleTheme';
import { useUserHasCollapsedNavBarFeature } from 'src/hooks/useUserHasFeature';
import { CommandOptionType } from 'src/WebApiController';

export const useGlobalCommandOptions = () => {
  // Fetch command menu options
  const { data, isLoading } = useCommandMenuOptions();

  // Regster global actions
  useToggleTheme();

  // Register global navigation commands
  const navigate = useNavigate();

  // POS-8591: collapsed nav (775) uses the dedicated nav icon set
  const hasCollapsedNavBar = useUserHasCollapsedNavBarFeature();

  const globalNavCommands: CommandOptionDisplay[] =
    !isLoading && data
      ? [...Object.values(AppRouteConfigs), ...Object.values(MenuItems)]
          .filter((route) => !!route.commandOptionType)
          .map((route) => ({
            id: route.view,
            label: route.label,
            onSelect: () => navigate(route.path),
            shortcut: data[route.commandOptionType as CommandOptionType],
            icon: hasCollapsedNavBar
              ? (route.collapsedNavIcon ?? route.icon)
              : route.icon,
          }))
      : [];

  return { globalNavCommands };
};
